"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Transactions_1 = __importDefault(require("../resources/Transactions"));
const DataModel_1 = __importDefault(require("./DataModel"));
class Block extends DataModel_1.default {
    constructor(client, block) {
        super();
        this.client = client;
        this.height = block.height;
        this.transactionCount = block.transaction_count;
        this.time = block.time;
        this.prevHash = block.prev_hash;
        this.hash = block.hash;
    }
    get transactions() {
        return new Transactions_1.default(this.client, this);
    }
    get data() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const _a = this, { client } = _a, rest = __rest(_a, ["client"]);
        return Object.assign({}, rest);
    }
}
exports.default = Block;
//# sourceMappingURL=Block.js.map